import { Box, Container, Grid } from "@mui/material";
import { cardUtility } from "../cards/CardUtil";
import ArmyListSearchWidget from "./components/ArmyListSearchWidget";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { getGameSystems } from "../../components/api/APIUtilities";
import { postNotification } from "../../components/utilities/Notifications";
import GameSystemPicker from "../../components/utilities/gamesystempickers/GameSystemPicker";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import ArmyListSearchWidgetV2 from "./components/ArmyListSearchWidgetV2";
import ModalLoadingMessage from "../../components/modals/ModalLoadingMessage";
import { useTranslation } from "react-i18next";

const SINGLE_GAMETYPE = getEnvironmentVariable("SINGLE_GAMETYPE");
const imageCache = {};

export default function ArmyListSearch(props) {
  const { userSearch, heading } = props;
  const navigate = useNavigate();
  const cardUtil = cardUtility();
  const { t } = useTranslation("translation", {
    keyPrefix: "components.ArmyListSearch"
  });

  const [loading, setLoading] = useState(SINGLE_GAMETYPE === undefined);
  const [ready, setReady] = useState(SINGLE_GAMETYPE !== undefined);
  const [gameSystems, setGameSystems] = useState(null);
  const [gameSystem, setGameSystem] = useState(null);

  useEffect(() => {
    const go = async () => {
      var apiGameSystems = await getGameSystems({
        // supportsDeckBuilder: true
      });
      if (!apiGameSystems?.length) {
        postNotification(
          t("noGameSystemsSetup", {
            gameSystemLabel: getEnvironmentVariable("LABEL_GAMESYSTEM")
          })
        );
        navigate("/");
        return;
      }
      setGameSystems(apiGameSystems);
      setLoading(false);
    };
    if (SINGLE_GAMETYPE === undefined) {
      go();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <Container
        sx={{
          pt: 2,
          pb: 2
        }}
        maxWidth="lg"
      >
        {!ready && gameSystems && (
          <Grid
            item
            xs={12}
            sx={{
              p: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              borderRadius: 1,
              boxShadow: 1,
              backgroundColor: "background.secondary"
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <GameSystemPicker
                  name="gameType"
                  value={gameSystem?.code || ""}
                  handleChange={(e) => {
                    if (e.target.value) {
                      gameSystems.forEach((gs) => {
                        if (gs.code === e.target.value) {
                          setGameSystem(gs);
                          setReady(true);
                          return true;
                        }
                      });
                    }
                  }}
                  gameSystems={gameSystems}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
        {ready && (
          <>
            {gameSystem?.supportsDeckBuilder ? (
              <ArmyListSearchWidget
                gameSystem={gameSystem}
                userSearch={userSearch}
                cardUtil={cardUtil}
                imageCache={imageCache}
                heading={heading || t("listSearch")}
              />
            ) : (
              <ArmyListSearchWidgetV2
                gameSystem={gameSystem}
                userSearch={userSearch}
                imageCache={imageCache}
                heading={heading || t("listSearch")}
              />
            )}
          </>
        )}
      </Container>
      {loading && (
        <ModalLoadingMessage message={t("loadingGameSystems")} open />
      )}
    </Box>
  );
}
